// COAR-53985: host-provided flag indicating the application has an outstanding
// verification stip (e.g. proof of income) that the customer must satisfy after
// esign. Sourced from the offers MFE and forwarded by the host as the `has-stip`
// attribute (presence = true, mirroring `title-follows`). When true, the esign
// flow suppresses the automated-funding thinker AND the success check mark and
// simply routes onward to wrap-up, so the customer is never shown a celebratory
// check mark right before a stip-upload page.
//
// Fails safe to "no stip": absent/false (including not-yet-determined, e.g. a
// resumed application that skipped offers or a partial deploy) leaves the normal
// flow untouched, so this can be released ahead of the host/offers changes.
let hasStip = false;

export const getHasStip = () => hasStip;

export const setHasStip = value => {
  hasStip = value === true || value === 'true';
};
